import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=0afc069f&scoped=true&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=0afc069f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc069f",
  null
  
)

export default component.exports